import { render, staticRenderFns } from "./HeaderInformationNavigationKh.vue?vue&type=template&id=b35886b0&scoped=true"
import script from "./HeaderInformationNavigationKh.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationKh.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationKh.vue?vue&type=style&index=0&id=b35886b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35886b0",
  null
  
)

export default component.exports